// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3WvZM","buttons":"PendingPaymentAlert_buttons__1cyHV"};